module.exports = __webpack_public_path__ + "static/media/1361_MessageEducation_unread_UH.8e89fc79.png";